import type { IFeebackPayload } from 'src/types';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

export async function postFeedback(runId: string, payload: IFeebackPayload) {
  const response = await axios.post(`/feedback/run/${runId}`, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
}

export function useSubmitFeedback() {
  const { mutate: submitFeedback } = useMutation({
    mutationFn: ({ runId, payload }: { runId: string; payload: IFeebackPayload }) =>
      postFeedback(runId, payload),
  });

  return {
    submitFeedback,
  };
}
